import { render, staticRenderFns } from "./DraggableTestDashboard.vue?vue&type=template&id=d4897772&scoped=true&"
import script from "./DraggableTestDashboard.vue?vue&type=script&lang=ts&"
export * from "./DraggableTestDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableTestDashboard.vue?vue&type=style&index=0&id=d4897772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4897772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSpacer,VToolbar,VToolbarTitle})
